/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from "react";

import { BodyContent, BodyContentProps } from "./body-content";
export type { BodyContentProps };

export const format = (body: BodyContentProps) => {
    if (!body) return {};

    const { story, richText, image, embeddedVideoLink, imageCaption } = body;

    const formattedBody: any = {
        storyText: story?.storyText ?? richText ?? undefined,
        bodyAsset: formatBodyAsset(story?.bodyAsset ?? image),
        embeddedVideoLink:
            story?.embeddedVideoLink ?? embeddedVideoLink ?? undefined,
        bodyAssetCaption: story?.bodyAssetCaption ?? imageCaption ?? undefined,
        quote: formatQuote(story?.quote)
    };

    // Remove undefined properties
    return Object.fromEntries(
        Object.entries(formattedBody).filter(
            ([_, value]) => value !== undefined
        )
    );
};

// eslint-disable-next-line complexity
const formatBodyAsset = (bodyAsset: any) => {
    if (!bodyAsset?.fields) return undefined;

    const { fields } = bodyAsset;
    return {
        name: fields.title,
        size: fields.file?.details?.size,
        fileName: fields.file?.fileName ?? null,
        height: fields.file?.image?.height ?? null,
        width: fields.image?.width ?? null,
        url: fields.file?.url,
        description: fields.description ?? null,
        contentType: fields.file?.contentType ?? null
    };
};

const formatQuote = (quote: any) => {
    if (!quote?.fields) return undefined;

    const { fields } = quote;
    return {
        quote: fields.advocateQuote,
        authorName: fields.advocateName,
        authorDetails: fields.advocateJobTitle
    };
};

const UniformBodyContent = (props: BodyContentProps) => {
    const bodyComponent = useMemo(() => format(props), [props]);

    return <BodyContent {...props} story={bodyComponent} />;
};

export default UniformBodyContent;
